import { ElateList } from '../../model/elate.model';
import { ElateActionsUnions, ElateActionTypes } from '../actions/elate.actions';

export interface ElateData {
  elateList: ElateList | null;
  current: any | null; // TODO: type
  loading: boolean;
  hasError: boolean;
  message: string | null;
}

export const initialState: ElateData = {
  elateList: null,
  current: null,
  loading: false,
  hasError: false,
  message: null
};

export function reducer(state = initialState, action: ElateActionsUnions): ElateData {
  switch (action.type) {
    case ElateActionTypes.GET_LISTING:
      return { ...state, loading: true };
    case ElateActionTypes.GET_LISTING_SUCCESS:
      return { ...state, elateList: action.payload, loading: false };
    case ElateActionTypes.GET_LISTING_FAILURE:
      return { ...state, elateList: null, loading: false };
    case ElateActionTypes.GET_LISTING_URL:
      return { ...state, loading: true };
    case ElateActionTypes.GET_ONE:
      return { ...state, loading: true };
    case ElateActionTypes.GET_ONE_SUCCESS:
      return { ...state, current: action.payload, loading: false };
    case ElateActionTypes.GET_ONE_FAILURE:
      return { ...state, current: null, loading: false };
    default:
      return state;
  }
}
